<div class="bs-digital-system-bet-bar-linear-container">
    <div class="system-bet-bar-pick-info">{{ pickCount() }} {{ messages.linear.Picks }}</div>
    @if (isBankerEnabled) {
        <div class="system-bet-bar-banker">
            <span class="system-bet-bar-banker-label">{{ messages.betslip.common.Banker }}</span>
            @if (isEpcot) {
                <span class="system-bet-bar-banker-info" (click)="toggleBankerHelp()">
                    <i class="system-bet-bar-banker-icon theme-info"></i>
                </span>
            }
            <button class="system-bet-bar-banker-btn" [class.selected]="isBankerActive()" (click)="toggleBanker()">
                {{ messages.betslip.common.BankerAbbr }}
            </button>
            @if (!isEpcot) {
                <span class="system-bet-bar-banker-info" (click)="toggleBankerHelp()">
                    <i class="system-bet-bar-banker-icon theme-info"></i>
                </span>
            }
        </div>
    }
</div>
<ng-template #titleTemplate let-title>
    <span class="system-bet-bar-dropdown-title">{{ title }}</span>
</ng-template>

<bs-info-message-container [messageId]="bankerHelpMessageId">
    <bs-digital-betslip-info [messages]="betslipInfoMessage" (close)="toggleBankerHelp()" />
</bs-info-message-container>

<div class="system-bet-bar-linear-bottom-line"></div>
